import { IBillingManagement } from "../../types/billing-management.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const makeRequestDebounced = createDebounce(makeRequest, 200);
const API_URL = `${import.meta.env.VITE_API_URL}/billing-management`;

export async function getBillingManagement({
  status = [],
  search = "",
  page = 1,
  itemsPerPage = 100,
  orderBy = "",
  splitDone = undefined,
  fields = "paymentId,customerId,splitDone,vehicleId,paymentStatus,invoiceNumber,licensePlate,splitWalletId,splitPercent,partnerId,partnerCompany,partnerWalletId",
}: {
  status?: string[];
  search?: string;
  page?: number;
  itemsPerPage?: number;
  orderBy?: string;
  splitDone?: boolean;
  fields?: string;
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });

  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }

  params.append("pageOptions[page]", String(page));
  params.append("pageOptions[itemsPerPage]", String(itemsPerPage));

  status && params.append("filters[status]", statusParam);
  splitDone && params.append("filters[splitDone]", splitDone.toString());

  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);

  const url = `${API_URL}/?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IBillingManagement[]
  > & { totalItems: number };
  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}
